// extracted by mini-css-extract-plugin
export var noOverflowHidden = "_b2-0";
export var optionCard = "_b2-1";